// extracted by mini-css-extract-plugin
export var container = "thematic-folders-module--container--ccf30";